import { ApiService } from "../../service/ApiService";

import { StoreActions } from "../../store/actions";
import { ContentActions } from "../../store/content/content.slice";

export const collectServerSideState = async (store, params) => {
  let meta;

  const res = await ApiService.getPageContent(params.tag, params.locale);
  const allCountries = await ApiService.getAllCountries(params.locale);
  const menuProxies = await ApiService.getMenuProxy(params.locale);

  meta = res.data;

  store.dispatch(
    StoreActions.serverSeoSave({
      data: meta,
      locale: params.locale,
      tag: params.tag,
    }),
  );

  store.dispatch(
    ContentActions.serverCountrySave({
      data: allCountries.data,
      languageCode: params.locale,
    }),
  );

  store.dispatch(
    ContentActions.serverMenuProxySave({
      data: menuProxies.data,
      languageCode: params.locale,
    }),
  );
};
